module.exports = __webpack_public_path__ + "static/media/nugl_cross.0ad19889.svg";